import { render, staticRenderFns } from "./update-requester-drawer.vue?vue&type=template&id=7c7f64b6"
import script from "./update-requester-drawer.vue?vue&type=script&lang=js"
export * from "./update-requester-drawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports